"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_LINKS_TO_ROTATE = exports.LOAD_STATS = void 0;
exports.LOAD_STATS = 'LOAD_STATS';
exports.SET_LINKS_TO_ROTATE = 'SET_LINKS_TO_ROTATE';
